import { FC, ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAppSelector } from 'src/redux/storeHooks'

type PermissionValue = 'WRITE' | 'RESTRICT' | 'FULL' | 'READ'

interface UserStaffGuardProps {
  permissionKey: string
  children: ReactNode
}

const UserStaffGuard: FC<UserStaffGuardProps> = ({
  permissionKey,
  children,
}) => {
  const {
    fetchedUserStaffData,
    fetchedUserAccountData,
  } = useAppSelector(state => state.userAccountData)

  const accountType = fetchedUserAccountData?.account_type

  /* ===============================
     USER_STAFF (existing logic)
     =============================== */
  const parentUserRole =
    fetchedUserAccountData?.parent_user_role ?? {
      billing_access: 'WRITE',
      customer_access: 'WRITE',
      integration_access: 'WRITE',
      other_access: 'RESTRICT',
      product_access: 'WRITE',
      sales_access: 'FULL',
      user_staff_management_access: 'FULL',
    }

  const isUserStaff =
    fetchedUserStaffData?.account_type === 'USER_STAFF'

  if (isUserStaff && accountType === 'DIRECT') {
    if (parentUserRole?.[permissionKey] === 'RESTRICT') {
      return <Navigate to="/account/settings" replace />
    }
  }

  /* ===============================
     ADMIN_STAFF (NEW logic)
     =============================== */
  if (accountType === 'ADMIN_STAFF') {
    const permissions =
      fetchedUserAccountData?.role?.flow_and_permissions

    if (
      permissions &&
      permissions[permissionKey as keyof typeof permissions] ===
        'RESTRICT'
    ) {
      return <Navigate to="/dashboard" replace />
    }
  }

  /* ===============================
     SUPERADMIN / Others → allow
     =============================== */
  return <>{children}</>
}

export default UserStaffGuard
